import React, { Component } from "react";
import { NavLink } from "react-router-dom";

export default class Naviation extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-12 navigation">
          <div className="row">
            <NavLink
              className="nav_links"
              activeClassName="active"
              exact
              to="/"
            >
              Presentation
            </NavLink>
            <NavLink
              className="nav_links"
              activeClassName="active"
              to="/orientations"
            >
              Orientations
            </NavLink>
            <NavLink
              className="nav_links"
              activeClassName="active"
              to="/perspectives"
            >
              Perspectives
            </NavLink>
            <NavLink
              className="nav_links"
              activeClassName="active"
              to="/ecosystem"
            >
              Ecosyst&egrave;me
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Navigation.js